// extracted by mini-css-extract-plugin
module.exports = {"date":"date--QrnNy","formFooter":"formFooter--3yvGC"};